<template>
  <div class="menuMask" @click="close">
    <div class="menuContainer" ref="menuContainer" @click.stop="">
      <div class="menuHead">
        <img :src="logo6" alt="" style="width: 16.93vw">
        <div class="operation">
          <div class="userImg">
            <img src="../../assets/images/Menu/userImage.svg" alt="">
          </div>
          <div class="btn" @click="$router.push('/Login')" v-if="!isLogin">
            {{ $t('lang.menu.Login') }}
          </div>
          <div class="userInfo" v-else>
            <div class="name">{{ truncatedName }}</div>
            <div class="tel">{{ $t('lang.menu.ID') }}:{{ UserShowId }}
              <div class="copyuserIdBtn" @click="copyId(UserShowId)">
                <img src="../../assets/images/Menu/copyUserIdBtn.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vipBox" :style="{backgroundImage:'url('+require('../../assets/images/Menu/vipCard.png')+')'}"
           v-if="isLogin">
        <div class="row1">
          <div class="VipText">Vip:{{ userVipLevel }}</div>
          <div class="Detail" @click="goto('vip')">{{ $t('lang.menu.Detail') }}</div>
        </div>
        <div class="row2">
          <div class="progress">
            <div class="progressBg"></div>
            <div class="progressBar" :style="{'width': precentVal+'%'}"></div>
            <div class="progressVal" v-if="nowReachedValue>0">{{
                convertLargeNumber(nowReachedValue)
              }}/{{ convertLargeNumber(targetValue) }}
            </div>
          </div>

        </div>
        <div class="row3" @click="goto('Account')">
          <div class="Balance">{{ $t('lang.menu.Balance') }}:</div>
          <div class="BalanceValue">₹{{ separateThousand($store.state.balance.Total) }}</div>
        </div>
      </div>
      <div class="menuList">
        <div ref="menu" class="menu" id="menu">
          <div class="menuContent">
            <div class="menuItem" v-if="isLogin" v-for="(item) in menuLogin" :key="item.label" @click="goto(item.href)">
              <img :src="item.src" alt="">
              <div>{{ item.label }}</div>
              <div :class="language==='IN'?'redHintE1':'redHintE'"
                   v-if="item.href === 'Edit' && $store.state.showUserInformationRedDot"></div>
              <div :class="language==='IN'?'redHintM1':'redHintM'"
                   v-if="item.href === 'Message' && $store.state.hasCashBonus"></div>
            </div>
            <!--            <div class="menuItem" key="vip" @click="goto('vip')">-->
            <!--              <img class="vip-logo" :src="vip" alt="">-->
            <!--              <div class="red-circle" v-show="$store.state.vipHint"/>-->
            <!--            </div>-->
          </div>
          <div class="menuContent">
            <div class="menuItem" v-for="(item) in menuCommon" :key="item.label" @click="goto(item.href)">
              <img :src="item.src" :style="item.height?'height:'+item.height:''" alt="">
              <div>{{ item.label }}</div>
            </div>
            <div id="chat-support" class="menuItem" @click="handleOpenChat">
              <img :src="support" alt="">
              <div>{{ $t('lang.menu.Support') }}</div>
            </div>
          </div>
          <div class="line" v-if="isH5"><img :src="menuLine" class="image" alt=""/></div>
          <div class="download" v-if="isH5" @click="downloadApp()">
            <div class="icon"><img :src="download" alt=""/></div>
            <div class="text"> {{ $t('lang.agent.download') }}</div>
          </div>
          <div class="logout" @click="logout" v-if="isLogin">
            {{ $t('lang.menu.Logout') }}
          </div>
          <div class="line2"/>
          <div class="languageChange">
            <div class="dropdown">
              <div class="dropdown-button" @click="toggleDropdown">
                <img class="countryImg" :src="internationName === 'English'?EnglandIcon:IndiaIcon" alt="">
                <div class="countryName">{{ internationName === 'English' ? 'English' : internationName }}</div>
                <span class="arrow" :class="{ 'arrow-up': isOpen }"><img src="../../assets/images/Menu/arrow.svg"
                                                                         alt=""></span>
              </div>
              <transition name="fade">
                <div class="dropdown-content" v-if="isOpen">
                  <div v-if="item.CountryNameLocal !== internationName" v-for="(item) in countryList"
                       :key="item.Language" class="dropdown-item" @click="selectCountry(item)">
                    <div class="item">
                      <img :src="item.img" alt="" class="languageIcon"/>
                      <div>{{ item.CountryNameLocal }}</div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div class="link" @click="goto('Terms')">{{ $t('lang.menu.Terms') }}</div>
          <div class="link" @click="goto('Privacy')">{{ $t('lang.menu.Privacy') }}</div>
          <div class="link" @click="goto('Responsible')">{{ $t('lang.menu.Responsible') }}</div>
          <!--          <div class="link" @click="goto('Kyc')">{{$t('lang.menu.Kyc')}}</div>-->
          <div class="link" @click="goto('AboutUs')">{{ $t('lang.menu.AboutUs') }}</div>
          <div class="version">
            <span>V{{ config.version }}</span>
          </div>
          <div class="showMore">
            <img :src="showMore" alt="" v-show="showArrow">
          </div>
        </div>
      </div>
    </div>
    <div :class="{'language-mask': showCountryDDL}" v-show="showCountryDDL" @click="closeLanguageSelect">
      <div class="language-container">
        <div class="language-top">
          <div class="language">{{ $t('lang.menu.Language') }}</div>
        </div>
        <div class="selectList">
          <div class="option pointer select-row"
               :class="{'selectactive':locale == item.Language}"
               v-for="(item, index) in countryList"
               :key="index" @click="selectCountry(item)">
            <img :src="require('../../../static/images/'+item.Language+'.png')" class="countryIcon" alt="Language"/>
            <span>{{ item.CountryNameLocal }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import download from '@/assets/images/account/download.svg'
import menuLine from '@/assets/images/account/menuLine.png'
import vip from '@/assets/images/account/vip.svg'
import logo from '@/assets/images/common/logo2.svg'
import FindUs from '@/assets/images/Menu/FindUs.svg'
import home from '@/assets/images/Menu/home.svg'
import promotions from '@/assets/images/Menu/promotions.svg'
import support from '@/assets/images/Menu/support.svg'
import account from '@/assets/images/Menu/account.svg'
import editInfo from '@/assets/images/Menu/editInfo.svg'
import history from '@/assets/images/Menu/history.svg'
import earn from '@/assets/images/Menu/earn.svg'
import mail from '@/assets/images/TopBar/mail.svg'
import mailNew from '@/assets/images/TopBar/mailNew.svg'
import showMore from '@/assets/images/common/showMore.gif'
import config from '../../../static/config/config'
import store from '../../store/store'
import request from '@/service'
import request2 from '@/service2'
import triangle from '@/assets/images/common/triangle.svg'
import {separateThousand, Storage, afListener, fbListener, LogUtils} from '@/utils'
import logo6 from '../../assets/images/Menu/logo6.svg'
import {Toast} from 'mint-ui'
import EnglandIcon from '../../assets/images/Menu/EnglandIcon.svg'
import IndiaIcon from '../../assets/images/Menu/IndiaIcon.svg'
// eslint-disable-next-line import/no-duplicates

export default {
  name: 'Menu',
  props: ['isLogin', 'userInfo'],
  data () {
    return {
      vip,
      logo,
      logo6,
      support,
      download,
      menuLine,
      showMore,
      EnglandIcon,
      IndiaIcon,
      separateThousand,
      isH5: !window.Android,
      userVipLevel: null,
      nowReachedValue: null,
      targetValue: null,
      precentVal: null,
      selectedLanguage: 'English',
      language: localStorage.getItem('locale'),
      isOpen: false,
      showArrow: true,
      UserShowId: null,
      config,
      countryList: [],
      triangle,
      internationName: localStorage.getItem('internationName') || 'English',
      languagePng: null,
      showCountryDDL: false,
      menuCommon: [
        {
          label: this.$t('lang.menu.Home'),
          src: home,
          href: 'Home'
        },
        {
          label: this.$t('lang.menu.FindUs'),
          src: FindUs,
          href: 'FindUs'
        },
        {
          label: this.$t('lang.menu.Promotion'),
          src: promotions,
          href: 'Promotion'
        }
      ],
      menuLogin: [
        {
          label: this.$t('lang.menu.Account'),
          src: account,
          href: 'Account'
        },
        {
          label: this.$t('lang.menu.Edit'),
          src: editInfo,
          href: 'Edit'
        },
        {
          label: this.$t('lang.menu.History'),
          src: history,
          href: 'History'
        },
        {
          label: this.$t('lang.menu.Affiliate'),
          src: earn,
          href: 'Earn'
        },
        {
          label: this.$t('lang.menu.Message'),
          src: this.$store.state.newMail ? mailNew : mail,
          href: 'Message'
        }
      ],
      locale: localStorage.getItem('locale')
    }
  },
  mounted () {
    this.getUserVipInfo()
    setTimeout(() => {
      if (this.$refs.menuContainer) {
        this.$refs.menuContainer.style.left = '0px'
      }
    })
    this.monitorDrag()
    this.$refs.menu.addEventListener('scroll', () => {
      this.monitorDrag()
    })
    this.unclaimedCashBonus()
    this.getInternationCountryList()
  },
  computed: {
    truncatedName () {
      // 获取用户名，优先使用 Vuex 状态，如果没有则使用 `userInfo.UserName`
      const name = this.$store.state.userName || this.userInfo.UserName || ''

      // 截取字符串，最大显示 14 个字符，超过的部分加省略号
      return name.length > 14 ? name.slice(0, 13) + '...' : name
    }
  },
  watch: {
    // 2022-03-27 CHP 监控语言切换更新菜单文字
    locale: function (val) {
      this.language = val
      this.menuCommon = [
        {
          label: this.$t('lang.menu.Home'),
          src: home,
          href: 'Home'
        },
        {
          label: this.$t('lang.menu.FindUs'),
          src: FindUs,
          href: 'FindUs'
        },
        {
          label: this.$t('lang.menu.Promotion'),
          src: promotions,
          href: 'Promotion'
        }
      ]
      this.menuLogin = [
        {
          label: this.$t('lang.menu.Account'),
          src: account,
          href: 'Account'
        },
        {
          label: this.$t('lang.menu.Edit'),
          src: editInfo,
          href: 'Edit'
        },
        {
          label: this.$t('lang.menu.History'),
          src: history,
          href: 'History'
        },
        {
          label: this.$t('lang.menu.Affiliate'),
          src: earn,
          href: 'Earn'
        },
        {
          label: this.$t('lang.menu.Message'),
          src: this.$store.state.newMail ? mailNew : mail,
          href: 'Message'
        }
      ]
      this.locale = localStorage.getItem('locale')
    }
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setInternationName: 'setInternationName',
      setInternation: 'setInternation'
    }),
    convertLargeNumber (number) {
      if (number === null) return null
      // 将数字转换为字符串
      const numStr = number.toString()

      // 检查数字的长度
      const numLength = numStr.length

      if (numLength <= 5) {
        // 如果数字长度小于等于6位，直接返回原数字
        return number.toString()
      } else if (numLength <= 9) {
        // 如果数字长度在6位到9位之间，转换为百万
        const millions = number / 1000000
        return `${millions.toFixed(2)}M`
      } else {
        // 如果数字长度超过9位，转换为十亿
        const billions = number / 1000000000
        return `${billions.toFixed(2)}B`
      }
    },
    getUserVipInfo () {
      let userInfo = localStorage.getItem('userInfo')
      if (userInfo) {
        request('post', 'innovation/vip/get_user_vip', {UserId: JSON.parse(localStorage.getItem('userInfo')).UserId}).then(res => {
          this.$store.state.userVipInfo = res.userVipInfo
          this.userVipLevel = this.$store.state.userVipInfo.VipLevel
          res.vipSettingInfo.forEach((item, index) => {
            if (item.VipLevel === this.userVipLevel) {
              if (index !== res.vipSettingInfo.length - 1) {
                this.nowReachedValue = res.vipSettingInfo[index + 4].ReachedValue
                this.targetValue = res.vipSettingInfo[index + 1].TargetValue
              } else {
                this.nowReachedValue = item.ReachedValue
                this.targetValue = item.TargetValue
              }
            }
          })
          const percent = (this.nowReachedValue / this.targetValue) * 100
          this.precentVal = percent > 100 ? 100 : percent
        })
      }
    },
    downloadApp () {
      LogUtils.downloadApp('ClickTopDown')
    },
    toggleDropdown () {
      this.isOpen = !this.isOpen
    },
    closeDropdown () {
      this.isOpen = false
    },
    copyId (id) {
      // 进行复制
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', id)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
      Toast(this.$t('lang.account.copySuccess'))
    },
    handleOpenChat () {
      if (this.userInfo && this.userInfo.UserShowId) {
        window.LiveChatWidget.call('set_customer_name', this.userInfo.UserShowId)
      } else {
        window.LiveChatWidget.call('set_customer_name', ' ')
      }
      window.LiveChatWidget.call('maximize')
    },
    monitorDrag () {
      // 有的时候浏览器会四舍五入长度单位 加5像素容错
      const scrollEle = this.$refs.menu
      this.showArrow = (scrollEle.scrollTop + 5) < (scrollEle.scrollHeight - scrollEle.clientHeight)
    },
    onShowCountryDDL () {
      this.showCountryDDL = !this.showCountryDDL
    },
    getInternationCountryList () {
      const url = '/innovation/internal/getinternationcountrylist'
      const data = {}
      request('post', url, data, false)
        .then(res => {
          this.countryList = res
          this.countryList.forEach(element => {
            if (element.Language === this.locale) {
              this.internationName = element.CountryNameLocal
              localStorage.setItem('internationName', element.CountryNameLocal)
            }
            switch (element.Language) {
              case 'IN':
                element.img = this.IndiaIcon
                break
              case 'EN':
                element.img = this.EnglandIcon
                break
              case 'BR':
                element.img = ''
                break
              default:
                element.img = this.EnglandIcon
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    /***
     * 选择国家版本
     * @param internation
     */
    selectCountry (internation) {
      this.setInternation(internation.CountryCode)
      // 2021-10-31 CHP 增加设置国家版本名字、语言
      this.setInternationName(internation.CountryNameLocal)
      localStorage.setItem('locale', internation.Language)
      localStorage.setItem('internationName', internation.CountryNameLocal)
      this.locale = internation.Language
      this.internationName = internation.CountryNameLocal
      this.$i18n.locale = internation.Language // localStorage.getItem('locale') // todo 切换版本
      this.$store.commit('setLocale', internation.Language)
      Storage.setExpire('locale', internation.Language, 7 * 24 * 3600)
      this.toggleDropdown()
    },
    /****
     * @param path
     * 2021-12-12 CHP Promotion打开弹窗
     */
    goto (path) {
      if (path === 'FindUs') {
        let end = ''
        if (localStorage.getItem('apkV') && localStorage.getItem('cid')) {
          end = '?cid=' + localStorage.getItem('cid') + '&v=' + localStorage.getItem('apkV')
        } else if (localStorage.getItem('apkV') && !localStorage.getItem('cid')) {
          end = '?v=' + localStorage.getItem('apkV')
        } else if (!localStorage.getItem('apkV') && localStorage.getItem('cid')) {
          end = '?cid=' + localStorage.getItem('cid')
        }
        if (window.Android) {
          end = end + '&a=true'
          window.location.href = 'https://playgoeasy.com' + end
        } else {
          end = end + '&a=false'
          window.open('https://playgoeasy.com' + end)
        }
      } else if (path === 'Promotions') {
        store.commit('setHidePromotionPop', false)
      } else if (this.$route.name !== path) {
        if (path === 'Accounts' || path === 'earn') {
          this.setCurrentRoute(path)
        } else if ((path.toLowerCase() === 'home' || path.toLowerCase() === 'vip') && this.$store.state.showGame) {
          this.$store.commit('setGameInfo', {})
          this.$store.commit('setShowGame', false)
        }
        this.$router.push('/' + path)
      }
      this.close()
    },
    logout () {
      LogUtils.logout9w()
      afListener('Logout')
      fbListener('Logout')
      window.LiveChatWidget.call('refresh')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('AnnouncementCode')
      localStorage.removeItem('SevenDayGiftModel')
      localStorage.removeItem('modals')
      this.$store.commit('setDepositListening', false)
      this.$store.commit('setShowInviteRedDot', false)
      this.$router.go(0)
    },
    close () {
      this.$parent.close()
    },
    closeLanguageSelect (e) {
      this.showCountryDDL = false
      e.stopPropagation()
    },
    unclaimedCashBonus () {
      let user = localStorage.getItem('userInfo')
      if (user !== null) {
        const url = '/innovation/newmessage/unclaimedcashbonus'
        const data = {
          userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
          messageType: 'system'
        }
        request2('post', url, data).then(res => {
          if (res > 0) {
            this.$store.commit('setMsgCount', res > 99 ? 99 : res)
            this.$store.commit('setIfHaveCashOrBonus', true)
          } else {
            this.$store.commit('setMsgCount', 0)
            this.$store.commit('setIfHaveCashOrBonus', false)
          }
        })
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (userInfo && !userInfo.UserShowId) {
          request('get', `innovation/account/get/showid?UserId=${JSON.parse(localStorage.getItem('userInfo')).UserId}`).then(res => {
            this.UserShowId = res.UserShowId
          })
        } else {
          this.UserShowId = userInfo.UserShowId
        }
        if (this.UserShowId) {
          userInfo.UserShowId = this.UserShowId
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.language-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .3);
  z-index: 101;

  .language-container {
    box-sizing: border-box;
    position: fixed;
    width: 280px;
    height: max-content;
    left: calc(50% - 140px);
    top: calc(50% - 80px);
    background: radial-gradient(41.41% 50% at 50% 50%, #2D2D2D 0%, #261C1C 100%);
    box-shadow: inset 0px 4px 13px 5px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    border: 1px solid;
    border-color: #8C8C8C;

    .language-top {
      width: 100%;
      padding: 10px 7px 7px 7px;
      border: 1px solid;
      border-radius: 8px 8px 0 0;
      border-color: #8C8C8C;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        height: 30px;
      }

      div {
        width: fit-content;
        margin: auto;
        text-align: center;
      }

      .language {
        color: #DBBE90;
        font-family: "Alibaba PuHuiTi 3.0";
        font-size: 23px;
        font-style: normal;
        font-weight: 900;
        line-height: normal;
        letter-spacing: 0.92px;
        text-transform: capitalize;
      }
    }

    .selectList {
      width: 100%;
      padding: 10px 0;
      text-align: left;
      z-index: 5;

      .option {
        padding: 1px 10px;
        margin: 5px 0;
        display: flex;
        width: 100%;
        font-family: 'Arial';
        font-style: normal;
        font-weight: 220;
        font-size: 22px;
        line-height: 30px;
        letter-spacing: 0.01em;
        align-items: center;

        .countryIcon {
          height: 36px;
          width: 36px;
          margin: 2px 22px 2px 20px;
          display: block;
        }

        span {
          height: 30px;
        }
      }

      .selectactive {
        color: #fff;
        background: linear-gradient(89.95deg, rgba(217, 217, 217, 0) -1.46%, #8d8d8d 54.88%, rgba(116, 116, 116, 0) 96.92%);
      }
    }
  }
}

.menuMask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .65);
  z-index: 100;

  .menuContainer {
    position: absolute;
    left: -300px;
    transition: left 0.5s;
    height: 100%;
    width: 74.04vw;
    display: flex;
    flex-direction: column;
    z-index: 101;

    .menuHead {
      padding: 10px;
      background-color: #202124;

      .operation {
        display: flex;
        align-items: center;
        padding-left: 3vw;

        .btn {
          background: #F6D9AA;
          padding-left: 7vw;
          padding-right: 7vw;
          height: 8vw;
          line-height: 8vw;
          border-radius: 1vw;
          color: #000;
          margin-left: 2vw;
        }

        .userImg {
          height: 11.11vw;
          width: 11.11vw;
          //border: 1px solid red;
          border-radius: 50vw;

          img {
            height: 100%;
            width: 100%;
          }
        }

        .userInfo {
          height: 100%;
          color: #F6D9AA;
          padding-left: 2vw;
          padding-top: 5vw;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-bottom: 2.5vw;

          .name {
            font-size: 3.88vw;
            line-height: 3.88px;
            font-weight: 700;
            margin-bottom: 5px;
            inline-size: 156px;
            overflow-wrap: break-word;
            padding-bottom: 2.5vw;
          }

          .tel {
            font-size: 3.33vw;
            line-height: 3.33vw;
            color: #fff;
            display: flex;

            .copyuserIdBtn {
              height: 3.33vw;
              width: 3.33vw;
              //border: 1px solid red;
              margin-left: 1vw;

              img {
                height: 100%;
                width: 100%;
              }
            }
          }
        }

        .locale {
          line-height: 32px;
          padding: 0 6px;
          display: flex;
          width: 80px;
          color: #000;
          border: 1px solid rgba(34, 34, 34, 1);
          border-radius: 5px;
          justify-content: space-between;
          /*border-radius: 50%;*/

          .loc-tag {
            margin-left: 8px;
            margin-right: 5px;
            width: 37px;
          }

          .tag {
            display: inline-flex;
            font-size: 18px;
            text-align: center;
            align-content: center;
            align-items: center;
            justify-content: center;

            .local-img {
              height: 12px;
              width: 12px;
            }
          }

          .countryIcon {
            height: 20px;
            width: 20px;
            margin: 2px 10px 2px 0px;
            display: block;
          }

          .rotate {
            transform: rotateZ(90deg);
          }
        }
      }
    }

    .vipBox {
      //padding-left: 2vw;
      //padding-right: 2vw;
      height: 24.22vw;
      background-color: #202124;
      //border: 1px solid red;
      //background-image: url("../../assets/images/Menu/vipCard.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 90%;

      .row1 {
        height: 9vw;
        margin-left: 7vw;
        //border: 1px solid red;
        margin-right: 7vw;
        display: flex;
        align-items: center;
        padding-top: 2vw;

        .VipText {
          margin-left: 5vw;
          font-size: 3.61vw;
          color: #000;
          font-weight: 700;
        }

        .Detail {
          border: 2px solid rgb(61, 33, 25);
          //width: 14.11vw;
          //height: 4.44vw;
          padding: .8vw 5vw .8vw 5vw;
          border-radius: 5vw;
          font-size: 3vw;
          color: rgb(61, 33, 25);
          font-weight: 500;
          margin-left: 3vw;
        }
      }

      .row2 {
        height: 5vw;
        margin-left: 7vw;
        margin-right: 7vw;
        //border: 1px solid red;
        .progress {
          position: relative;
          width: 46.94vw;
          left: -3vw;
          //margin-left: 1vw;
          .progressBg {
            height: 1.672vw;
            width: 100%;
            background-color: #000;
            border-radius: 2vw;
            position: absolute;
            left: 1vw;
            top: 1.4vw;
          }

          .progressBar {
            height: 1.672vw;
            //width: 50%;
            background-image: linear-gradient(to right, #CB2427, #F52424);
            border-radius: 2vw;
            position: absolute;
            left: 1vw;
            top: 1.4vw;
          }

          .progressVal {
            color: #000;
            font-size: 2.7vw;
            position: absolute;
            left: 48.5vw;
            top: 0.75vw;
          }
        }

      }

      .row3 {
        display: flex;
        align-items: center;
        position: relative;
        height: 5vw;
        //border: 1px solid red;
        top: 2vw;

        .Balance {
          font-weight: 700;
          font-size: 3.33vw;
          margin-left: 7.5vw;
          color: #000;
        }

        .BalanceValue {
          font-size: 3vw;
          color: #000;
          margin-left: 2vw;
          margin-top: .5vw;
        }
      }
    }

    .menuList {
      position: relative;
      flex: 1;
      background-color: #202124;
      overflow: hidden;

      .menu {
        height: 96%;
        overflow-x: hidden;
        overflow-y: auto;

        .menuItem {
          margin: 0 20px 9px 20px;
          display: flex;
          align-items: center;
          position: relative;

          img {
            width: 24px;
            margin-right: 18px;
          }

          .vip-logo {
            width: 100%;
            height: 100%;
          }

          .red-circle {
            position: absolute;
            top: 0;
            right: 0;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: red;
            z-index: 3;
            overflow: visible;
            color: #686868;
            display: block;
            unicode-bidi: isolate;
          }

          div {
            font-size: 18px;
            line-height: 21px;
            color: #F6D9AA;
          }

          .redHintE {
            position: absolute;
            width: 2.2vw;
            height: 2.2vw;
            border-radius: 6px;
            background-color: red;
            top: 0;
            right: 29vw;
          }

          .redHintE1 {
            position: absolute;
            width: 2.2vw;
            height: 2.2vw;
            border-radius: 6px;
            background-color: red;
            top: 0;
            right: 4vw;
          }

          .redHintM {
            position: absolute;
            width: 2.2vw;
            height: 2.2vw;
            border-radius: 6px;
            background-color: red;
            top: 0;
            right: 27vw;
          }

          .redHintM1 {
            position: absolute;
            width: 2.2vw;
            height: 2.2vw;
            border-radius: 6px;
            background-color: red;
            top: 0;
            right: 35vw;
          }
        }

        .menuContent {
        }

        .link {
          margin: 0 auto;
          color: #565656;
          font-size: 12px;
          line-height: 30px;
          width: 62.4vw;
        }

        .version {
          margin: 0 auto;
          width: 62.4vw;
          color: #2F2F2F;
          font-size: 12px;
          text-align: left;
        }
      }

      .menu::-webkit-scrollbar {
        display: none
      }

      .line {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        height: 2px;
        width: 62.4vw;
        padding:0;

        .image {
          width: auto;
          height: 2px;
        }
      }
      .download {
        display: flex;
        height: 39px;
        width: 62.4vw;
        justify-content: flex-start;
        align-items: center;
        margin: 6px auto;

        .icon {
          width: 24px;
          height: 24px;
          margin-right: 18px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .text {
          line-height: 6.666vw;
          font-family: Inter;
          font-weight: 500;
          font-size: 4.444vw;
          text-transform: capitalize;
          color: #F6D9AA;
        }
      }

      .logout {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        width: 62.4vw;
        height: 8.88vw;
        color: #5A5A5A;
        border-radius: 0.833vw;
        font-size: 4.44vw;
        text-align: center;
        line-height: 8vw;
        border: 0.3vw solid #5A5A5A;
        font-family: Inter;
        font-weight: 500;
        text-transform: capitalize;
        margin-bottom: 6.11vw;
      }

      .showMore {
        position: absolute;
        bottom: 11.5%;
        right: 25px;
        width: 10px;
        height: 10px;
        z-index: 5;

        img {
          width: 10px;
          height: auto;
        }
      }
    }

    .line2 {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      height: 1px;
      width: 62.4vw;
      background-color: #444444;
    }

    .languageChange {
      position: relative;
      height: 39px;
      margin: 0 auto;
      padding-top: 2vw;
      z-index: 4;

      .dropdown {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        width: 62.4vw;

        .dropdown-button {
          width: 62.4vw;
          height: 39px;
          background: #202124;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .countryImg {
            margin-right: 9px;
          }

          .countryName {
            color: #fff;
            font-family: Inter;
            font-weight: 400;
            font-size: 13px;
            line-height: 100%;
            text-transform: capitalize;
          }

          .arrow {
            position: absolute;
            left: 58vw;
            transition: transform 0.3s ease;
            transform: rotate(180deg);
            top: 2vw;
          }

          .arrow-up {
            transform: rotate(360deg);
            transform-origin: center center;

            //transform-origin: center center; /* 或者使用 50% 50%，这是默认值 */
          }
        }

        .dropdown-content {
          position: absolute;
          left: -5.82vw;
          background-color: #2C2D32;
          width: 74vw;
          padding-left: 5.82vw;
          z-index: 1;

          .dropdown-item {
            position: relative;
            color: #5A5A5A;
            height: 29px;
            display: flex;
            align-items: center;

            .item {
              position: relative;
              font-family: Inter;
              font-weight: 400;
              font-size: 13px;
              text-transform: capitalize;
              display: flex;
              justify-content: flex-start;

              .languageIcon {
                margin-right: 9px;
              }
            }
          }
        }
      }

      .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
      }

      .fade-enter, .fade-leave-to {
        opacity: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/index.vue